import { OnboardingHubUser } from "../../models/user";
import { OnboardingRootState } from "../reducers/rootReducer";

export enum SignedInState {
  Unset = "Unset",
  SignedIn = "SignedIn",
  SignedOut = "SignedOut",
}

export const getOnboardingSignInState = (state: OnboardingRootState): SignedInState => {
  const auth = state["publisher-onboarding"].auth;
  if (!auth.isFetched) {
    return SignedInState.Unset;
  }

  return auth.userInfo ? SignedInState.SignedIn : SignedInState.SignedOut;
};

export const getOnboardingSignedIn = (state: OnboardingRootState): boolean =>
  !!state["publisher-onboarding"]?.auth?.userInfo ?? false;

export const getOnboardingUser = (state: OnboardingRootState): OnboardingHubUser | undefined =>
  state["publisher-onboarding"].auth?.userInfo;
